import { MOBILE_VIEWPORT_QUERY } from './bowerClient';

/**
 * Whether this browser gets the phone shell, read now without subscribing.
 * Mirrors `isMobile` in `useMobileDetection` (a small screen on a touch
 * device) on the app's one mobile-width rule, `MOBILE_VIEWPORT_QUERY`. For code
 * that only needs the answer at the moment it acts (the boot preload, a toast
 * firing): the hook re-renders its caller on every breakpoint change, which at
 * the app root is the whole tree.
 */
export function isPhoneViewport(): boolean {
  if (typeof window.matchMedia !== 'function') return false;
  const small = window.matchMedia(MOBILE_VIEWPORT_QUERY).matches;
  const touch = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  return small && (touch || /iphone|ipad|ipod|android/i.test(navigator.userAgent));
}
